export default __webpack_public_path__ + "static/media/WIBS.4271e801.svg";